export const routes = {
    "/:taskId/bbvConsultation": {
        title: "Blood Borne Virus Consultation"
    }
};
